import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/batches/$batchId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/admin/batches/$batchId/enrollment',
      params,
    });
  },
});
